import styled from 'styled-components'

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const TagInput = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${(prop) => prop.background};
  border: 1px solid #000000;
  border-radius: 10px;
  margin: 5px;
  padding: 5px 1px 7px 15px;
  align-items:center;
  cursor: ${(prop) => prop.editableTag ? 'pointer' : 'default'};
  position: relative;

  .editIcon {
    display: none;
    position: absolute;
    top: -10px;
    right: 10px;
    width: 20px;
    height: 20px;
    border: 1px solid #000000;
    background-color: #ffffff;
    border-radius: 50%;
    padding: 2px;
  }

  &:hover {
    .editIcon {
      display: ${(props) => props.editableTag ? 'block' : 'none'};
    }
  }
`

export const TagText = styled.div`
  margin-right: 5px;
`
export const TagIcon = styled.button`
  margin-right: 5px;
  font-size: 10px;
  margin-top: 4px;
  border-width: 0px;
  background-color: ${(prop) => prop.background};
  transition-duration: 0.4s;
  min-height:28px;
  min-width:28px;
  &:hover {
    background-color: #d3d3d3;
    border-radius: 100%;
    color: black;
  }
`
/* Language tags styles */
export const LanguageTagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const LanguageTagInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
  background-color: ${(prop) => prop.background};
  border: 1px solid #000000;
  border-radius: 10px;
  margin: 5px;
  padding: 5px 1px 7px 15px;
  height: 4.2rem;
  white-space: initial;
  cursor: ${(prop) => prop.editableTag ? 'pointer' : 'default'};
  position: relative;

  .editIcon {
    display: none;
    position: absolute;
    top: -10px;
    right: 10px;
    width: 20px;
    height: 20px;
    border: 1px solid #000000;
    background-color: #ffffff;
    border-radius: 50%;
    padding: 2px;
  }

  &:hover {
    .editIcon {
      display: ${(props) => props.editableTag ? 'block' : 'none'};
    }
  }
`
export const LanguageTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 19px;
`

export const LanguageTagText = styled.div`
  margin-right: 5px;
  font-weight: bold;
  font-size: 1rem;
  line-height: 19px;
`

export const LanguageLevelText = styled.div`
  margin-right: 5px;
  font-size: 0.875rem;
  top: 4px;
  line-height: 19px;
`
export const LanguageTagIcon = styled.button`
  margin-right: 5px;
  padding: 5px;
  font-size: 10px;
  margin-top: 4px;
  border-width: 0px;
  background-color: ${(prop) => prop.background};
  transition-duration: 0.4s;
  &:hover {
    background-color: #d3d3d3;
    border-radius: 100%;
    color: black;
  }
`
export const LanguageCodeIcon = styled.span`
  align-items: center;
  border-radius: 50%;
  background-color: black;
  color: white;
  display: flex;
  font-weight: 700;
  font-size: 1rem;
  height: 41px;
  justify-content: center;
  line-height: 19px;
  text-transform: uppercase;
  width: 41px;
  max-width: 41px;
`
